import React from 'react';
import get from 'lodash.get';
import { of } from 'rxjs';
import { defineMessages, FormattedMessage } from 'react-intl';
import * as Actions from '../../../store/printing/print.actions';
import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';

import { NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_INFO } from 'ui-components/services/notification-service';

import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  printingPickListSuccessTitle: {
    description: 'printEpics.printingPickListSuccessTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}}...',
    id: 'ODpmZ4',
  },
  printingPickListSuccessContent: {
    description: 'printEpics.printingPickListSuccessContent',
    defaultMessage: '{docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}} sent to {printerName}.',
    id: 'HGybJm',
  },
  downloadPickListsStartedTitle: {
    description: 'printEpics.downloadPickListsStartedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}}...',
    id: '/tjxeB',
  },
  downloadPickListsStartedContent: {
    description: 'printEpics.downloadPickListsStartedContent',
    defaultMessage: '{docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}} Download Started.',
    id: 'wBLWh4',
  },
  downloadPickListsCompletedTitle: {
    description: 'printEpics.downloadPickListsCompletedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}}...',
    id: 'etX/sa',
  },
  downloadPickListsCompletedContent: {
    description: 'printEpics.downloadPickListsCompletedContent',
    defaultMessage: '{docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}} Download Completed.',
    id: 'JwWK0+',
  },
  asyncPrintPickListStartedContent: {
    description: 'Notification message shown when generating a pick list',
    defaultMessage: 'We are generating your {docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}}.',
    id: 'U4wWR5',
  },
  asyncPrintPickListFailedContent: {
    description: 'Notification message shown when generating a pick list fails',
    defaultMessage: 'Failed to generate {docCount, plural,=0 {Pick List} one {Pick List} other {Pick Lists}}. Please try again.',
    id: 'DJGFW2',
  },
});

export const pickList = {
  id: DocumentType.PickList.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadPickListsStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadPickListsStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadPickListsCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadPickListsCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingPickListSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingPickListSuccessContent} values={{ docCount, printerName }} />,
  }),

  getAsyncPrintStartedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPickListSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintPickListStartedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_INFO,
  }),

  getAsyncPrintFailedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPickListSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintPickListFailedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
    duration: NOTIFICATION_DURATIONS.MEDIUM,
  }),

  getPrintedSuccessObservable: (printJob) => {
    const printJobIds = get(printJob, 'ids');
    const printJobRequestId = get(printJob, 'requestId');
    return of(Actions.markPickListPrinted(printJobIds, true), ConnectActions.printDocumentComplete(printJobRequestId));
  },
};
